<template>
	<el-row>
		<el-button type="primary" @click="add" size="mini">+添加</el-button>
		<el-row style="margin: 10px 0;">
			<el-col :span="5">
				<div class="search-view">
					<div>
						专区名称:
					</div>
					<el-input placeholder="专区名称搜索" size="mini" v-model="name" />
				</div>
			</el-col>
			<el-col :span="8">
				<div class="search-view">
					<div>
						状态:
					</div>
					<el-select size="mini" v-model="status" clearable placeholder="全部">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-button type="primary" size="mini" style="margin-left: 10px;" @click="shuaixuan">筛选</el-button>
					<el-button type="warning" size="mini" style="margin-left: 10px;" @click="zhikong">置空</el-button>
				</div>
			</el-col>
		</el-row>
		<el-table :data="tableDate">
			<el-table-column label="序号" prop="id" width="50px"></el-table-column>
			<el-table-column label="专区名称" prop="name" width="100px"></el-table-column>
			<el-table-column label="专区描述" prop="describes"> </el-table-column>
			<el-table-column label="栏目" prop="columnName"></el-table-column>
			<el-table-column label="专区排序" prop="sort" width="70px"></el-table-column>
			<el-table-column label="状态" prop="status">
				<template slot-scope="scope">
					<el-switch :active-value="0" :inactive-value="1" @change="isStatus(scope.row)" active-text="正常"
						inactive-text="禁用" v-model="scope.row.status">
					</el-switch>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" prop="created"></el-table-column>
			<el-table-column label="操作" prop="id">
				<template slot-scope="scope">
					<el-button type="text" @click="del(scope.row)">
						删除
					</el-button>
					<el-button type="text" size="mini" @click="xiuagi(scope.row)">
						修改
					</el-button>
					<el-button type="text" size="mini" @click="lmsezhi(scope.row)">
						栏目设置
					</el-button>
					<el-button type="text" size="mini" @click="zqkec(scope.row)">
						专区课程
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin: 20px auto;width: 500px">
			<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
				:page-size="pageSize" :page-sizes="pagelist" :total="total" :current-page.sync="pageNum"
				@size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="30%" center>
			<el-form ref="info2" :model="info2" label-position="right" label-width="90px">
				<el-form-item label="专区名称:" prop="name" :rules="[{ 
						required: true, message: '请输入专区名称', trigger: 'blur' }]">
					<el-input size="mini" v-model="info2.name"></el-input>
				</el-form-item>
				<el-form-item label="专区排序:" prop="sort" :rules="[{ 
						required: true, message: '请输入专区排序', trigger: 'blur' }]">
					<el-input-number v-model="info2.sort" :min="1"></el-input-number>
				</el-form-item>
				<el-form-item label="专区描述:">
					<el-input size="mini" v-model="info2.describes" placeholder="20字" maxlength="20" show-word-limit>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="centerDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="queren">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>


		<el-dialog :title="title" :visible.sync="centerDialogVisible2" width="50%" center @close="gb">
			<el-table :data="dynamicTags">
				<el-table-column prop="id" label="id" width="50px"></el-table-column>
				<el-table-column prop="name" label="名称">
					<template slot-scope="scope">
						<el-input v-model="scope.row.name" :disabled="scope.row.disabled"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="sort" label="排序">
					<template slot-scope="scope">
						<el-input v-model="scope.row.sort" :disabled="scope.row.disabled" type="number">
						</el-input>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button @click="bj(scope.row,scope.$index)">
							{{ scope.row.disabled ?'编辑' : '完成'}}
						</el-button>
						<el-button @click="del2(scope.row,scope.$index)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div v-if="dynamicTags.length<5">
				<el-form v-if="inputVisible" label-position="right" label-width="100px" :model="info" ref="info"
					style="width: 400px;margin: 20px auto;">
					<el-form-item label="栏目名称:" prop="name" :rules="[{
						required: true, message: '请输入栏目名称', trigger: 'blur'
					}]">
						<el-input v-model="info.name" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="栏目排序:" prop="sort" :rules="[{
						required: true, message: '请输入栏目排序', trigger: 'blur'
					}]">
						<el-input v-model="info.sort" type="number"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button size="small" @click="inputVisible = false">取消</el-button>
						<el-button size="small" @click="sub" type="primary">确认</el-button>
					</el-form-item>
				</el-form>
				<el-button v-if="!inputVisible" class="button-new-tag" size="small" @click="showInput">
					添加栏目
				</el-button>
				<p style="color: #A5673F;">提示：最多可添加5个栏目</p>
			</div>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				total: 0,
				pageNum: 1,
				pageSize: 30,
				pagelist: [30, 50, 100],
				status: "",
				name: '',
				tableDate: [],
				isShow: false,
				dynamicTags: [],
				inputVisible: false,
				inputValue: '',
				centerDialogVisible: false,
				centerDialogVisible2: false,
				title: "",
				info2: {
					name: '',
					sort: 1,
					describes: '',
					id: '',
					deleteStatus: '',
				},
				info3: {
					specialAreaId: "",
					sort: ''
				},
				info: {
					name: '',
					sort: 1
				},
				rowId: '',
				options: [{
						value: "",
						label: '全部'
					}, {
						value: 0,
						label: '正常'
					},
					{
						value: 1,
						label: '禁用'
					}
				],

			}
		},
		methods: {
			//添加专区
			add() {
				this.title = '添加'
				this.centerDialogVisible = true
				this.info2.describes = ""
				this.info2.sort = ""
				this.info2.name = ""
			},
			shuaixuan() {
				this.getInfo()
			},
			zhikong() {
				this.status = ''
				this.name = ''
				this.getInfo()
			},
			del(row) {
				console.log(row.id, row.deleteStatus);
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post(`/api/course/SiteManageController/updateSpecialArea`, {
						id: row.id,
						deleteStatus: 1,
					}).then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							this.$message.success("删除专区成功")
							this.centerDialogVisible = false
							this.getInfo()
						} else {
							this.$message.error(res.data.data)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			xiuagi(row) {
				console.log(row);
				this.title = '修改'
				this.info2.id = row.id
				this.centerDialogVisible = true
				this.info2.describes = row.describes
				this.info2.sort = row.sort
				this.info2.name = row.name
			},

			zqkec(row) {
				console.log(row);
				this.$router.push({
					path: './zoneManagement',
					query: {
						id: row.id
					}
				})
			},
			queren() {
				this.$refs.info2.validate(valid => {
					if (valid) {
						if (this.title == "添加") {
							this.$http.post(`/api/course/SiteManageController/addSpecialArea`, {
								name: this.info2.name, //名字  字符串
								describes: this.info2.describes, //描述  字符串
								sort: this.info2.sort //排序  是个数字
							}).then(res => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success(res.data.data.data)
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									this.$message.error(res.data.data)
								}
							})
						} else if (this.title == "修改") {
							this.$http.post(`/api/course/SiteManageController/updateSpecialArea`, {
								id: this.info2.id,
								name: this.info2.name,
								describes: this.info2.describes,
								sort: this.info2.sort,
							}).then(res => {
								console.log(res);
								if (res.data.data.status == 0) {
									console.log(res.data.data.data);
									this.$message.success(res.data.data.data)
									this.centerDialogVisible = false
									this.getInfo()
								} else {
									console.log(res.data.data.msg);
									this.$message.error(res.data.data.msg)
								}
							})
						}
					}
				})
			},
			//栏目设置
			lmsezhi(row) {
				this.rowId = row.id
				this.dynamicTags = []
				this.$http.get(`/api/course/SiteManageController/selectAreaByColumn?id=${row.id}`).then(res => {
					let newdata = res.data.data.data
					newdata.forEach(i => {
						this.dynamicTags.push({
							name: i.name,
							id: i.id,
							sort: (i.sort) - 0,
							disabled: true
						})
					})
				})
				console.log(this.dynamicTags);
				this.title = '栏目设置'
				this.centerDialogVisible2 = true
				this.info3.sort = row.sort - 0
				this.info3.specialAreaId = row.id
			},
			handleClose(item) {
				console.log(item);
				this.$confirm('此操作将永久删除该栏目, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/course/SiteManageController/deleteColumn?id=' + item.id, {}).then(res => {
						console.log(res);
						return false
						if (res.data.data.status == 1) {
							this.$message.error(res.data.msg)
						} else if (res.data.status == 0) {
							this.dynamicTags.splice(this.dynamicTags.indexOf(item), 1);
							this.$message.success("删除栏目成功")
							this.centerDialogVisible2 = false
							this.getInfo()
						} else {
							this.$message.error(res.data.data)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			showInput() {
				this.inputVisible = true;
				this.info = {
					name: '',
					sort: 1
				}
			},
			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					if (this.dynamicTags.length > 0) {
						if (this.dynamicTags.indexOf(inputValue) == -1) {
							this.$http.post(`/api/course/SiteManageController/addColumn`, {
								name: inputValue, //名字  (字符串)
								specialAreaId: this.info3.specialAreaId, //专区id  (数字类型)
								sort: this.info3.sort //排序  (数字类型)
							}).then(res => {
								console.log(res);
								this.getInfo()
								this.$http.get(
										`/api/course/SiteManageController/selectAreaByColumn?id=${this.rowId}`)
									.then(res => {
										let newdata = res.data.data.data
										console.log(newdata);
										this.dynamicTags = []
										newdata.forEach(i => {
											this.dynamicTags.push({
												name: i.name,
												id: i.id
											})
										})
									})
							})
						} else {
							this.$message.error('请勿重复添加')
						}
					} else {
						this.$http.post(`/api/course/SiteManageController/addColumn`, {
							name: inputValue, //名字  (字符串)
							specialAreaId: this.info3.specialAreaId, //专区id  (数字类型)
							sort: this.info3.sort //排序  (数字类型)
						}).then(res => {
							console.log(res);
							this.getInfo()
							this.$http.get(`/api/course/SiteManageController/selectAreaByColumn?id=${this.rowId}`)
								.then(res => {
									let newdata = res.data.data.data
									console.log(newdata);
									this.dynamicTags = []
									newdata.forEach(i => {
										this.dynamicTags.push({
											name: i.name,
											id: i.id
										})
									})
								})
						})

					}
				}
				this.inputVisible = false;
				this.inputValue = '';
			},
			sub() {
				this.$refs.info.validate((valid) => {
					if (valid) {
						this.$http.post(`/api/course/SiteManageController/addColumn`, {
							name: this.info.name, //名字  (字符串)
							specialAreaId: this.info3.specialAreaId, //专区id  (数字类型)
							sort: this.info.sort //排序  (数字类型)
						}).then(res => {
							console.log(res);
							if (res.data.status == 0) {
								this.$message.success('添加成功')
								this.dynamicTags = []
								this.$http.get(
									`/api/course/SiteManageController/selectAreaByColumn?id=${this.info3.specialAreaId}`
								).then(res => {
									let newdata = res.data.data.data
									console.log(newdata);
									newdata.forEach(i => {
										this.dynamicTags.push({
											name: i.name,
											id: i.id,
											sort: i.sort - 0,
											disabled: true
										})
									})
								})
								this.getInfo()
								this.inputVisible = false
							}
						})
					}
				})
			},
			bj(row, index) {
				console.log(row, index);
				row.disabled = !row.disabled
				if (row.disabled) {
					console.log(row.name, row.sort);
					this.$http.post('/api/course/SiteManageController/editColumn', {
						"id": row.id,
						"name": row.name,
						"sort": row.sort
					}).then(res => {
						if (res.data.status == 0) {
							this.$message.success("修改栏目成功")
							// this.centerDialogVisible2 = false
							// this.getInfo()
							this.dynamicTags = []
							this.$http.get(
								`/api/course/SiteManageController/selectAreaByColumn?id=${this.info3.specialAreaId}`
							).then(res => {
								let newdata = res.data.data.data
								console.log(newdata);
								newdata.forEach(i => {
									this.dynamicTags.push({
										name: i.name,
										id: i.id,
										sort: i.sort - 0,
										disabled: true
									})
								})
							})
						} else {
							this.$message.error(res.data.data)
						}
					})
				}
			},
			del2(row, index) {
				console.log(row);
				this.$confirm('此操作将永久删除该栏目, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/course/SiteManageController/deleteColumn?id=' + row.id, {}).then(res => {
						console.log(res.data.status);
						if (res.data.data.status == 1) {
							this.$message.error(res.data.data.msg)
						} else if (res.data.status == 0) {
							this.$message.success("删除栏目成功")
							// this.centerDialogVisible2 = false
							// this.getInfo()
							this.dynamicTags = []
							this.$http.get(
								`/api/course/SiteManageController/selectAreaByColumn?id=${this.info3.specialAreaId}`
							).then(res => {
								let newdata = res.data.data.data
								console.log(newdata);
								newdata.forEach(i => {
									this.dynamicTags.push({
										name: i.name,
										id: i.id,
										sort: i.sort,
										disabled: true
									})
								})
							})
						} else {
							this.$message.error(res.data.data)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			gb() {
				this.getInfo()
			},
			//改变状态
			isStatus(row) {
				console.log(row);
				this.$http.post(`/api/course/SiteManageController/updateSpecialArea`, {
					id: row.id,
					status: row.status == 1 ? 1 : 0, //状态
				}).then(res => {
					console.log(res.data.data);
				})
			},
			getInfo() {
				this.$http.get(
					`/api/course/SiteManageController/selectAllAreaInfo?status=${this.status}&pageSize=${this.pageSize}&pageNum=${this.pageNum}&name=${this.name}`, {}
				).then(res => {
					console.log(res.data.data.data.list);
					this.tableDate = res.data.data.data.list
					this.total = res.data.data.data.total
				})
			},
			//页面的条数发生改变时
			handleSizeChange(size) {
				this.pageSize = size
				//重新请求数据
				this.getInfo()
			},
			//当前页发生改变时
			handleCurrentChange(currentPage) {
				this.pageNum = currentPage
				//重新请求数据
				this.getInfo()
			},
		},
		created() {
			this.getInfo()
		}
	}
</script>

<style scoped="scoped">
	/deep/ .el-input-number__increase {
		right: -38px;
	}

	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}
</style>
